import React from 'react';
import {PaymentLoginDetails} from './PaymentStatusNotice';
import {formatPaymentDate} from './paymentStatus';

const labels = {paid: 'Bezahlt', pending: 'Ausstehend', overdue: 'Überfällig'};
const intervals = {monthly: 'Monatlich', quarterly: 'Vierteljährlich', yearly: 'Jährlich'};

export default function PaymentDetails({status, loading = false, error = false, onRefresh}) {
  const amount = typeof status?.betrag === 'number'
    ? new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(status.betrag)
    : 'Nicht verfügbar';
  return (
    <section aria-label="Zahlung">
      <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">Zahlung</h2>
          <p className="mt-1 text-sm text-gray-500">Zahlungsstatus und Zugang zu Payment Kantine</p>
        </div>
        <button type="button" onClick={onRefresh} disabled={loading}
          className="rounded-lg border px-4 py-2 text-sm font-medium disabled:opacity-50">
          {loading ? 'Wird geladen …' : 'Aktualisieren'}
        </button>
      </div>
      {error && <p role="alert" className="mb-4 text-amber-800">Der Zahlungsstatus konnte nicht aktualisiert werden. Vorhandene Angaben können veraltet sein.</p>}
      {!status ? (
        <p className="text-gray-600">{loading ? 'Zahlungsdaten werden geladen …' : 'Keine Zahlungsdaten für diese Wachabteilung verfügbar. Bitte die Payment-Zuordnung und Synchronisierung prüfen lassen.'}</p>
      ) : (
        <>
          <dl className="grid grid-cols-1 gap-5 sm:grid-cols-2">
            {[
              ['Zahlungsstatus', labels[status.status] || 'Unbekannt'],
              ['Betrag', amount],
              ['Zahlungsintervall', intervals[status.intervall] || status.intervall || 'Nicht verfügbar'],
              ['Nächste Zahlung fällig', formatPaymentDate(status.naechste_zahlung_faellig) || 'Nicht verfügbar'],
              ['Letzte Zahlung', formatPaymentDate(status.letzte_zahlung) || 'Keine Zahlung gemeldet'],
              ['Bezahlt bis', formatPaymentDate(status.paid_until) || 'Nicht verfügbar'],
            ].map(([label, value]) => <div key={label}>
              <dt className="text-sm text-gray-500">{label}</dt>
              <dd className="mt-1 font-medium text-gray-900">{value}</dd>
            </div>)}
          </dl>
          <div className="mt-6 rounded-lg border border-gray-200 p-4">
            <h3 className="font-semibold">Payment Kantine</h3>
            {status.user_username || status.payment_dashboard_url
              ? <PaymentLoginDetails status={status} />
              : <p className="mt-2 text-sm text-gray-600">Für diese Wachabteilung wurden noch keine Payment-Zugangsdaten übermittelt.</p>}
          </div>
          <p className="mt-4 text-xs text-gray-500">Die Angaben stammen aus der letzten Payment-Synchronisierung. Verbindliche Vertrags- und Zahlungsdaten findest du im Payment-Dashboard.</p>
        </>
      )}
    </section>
  );
}
